import { useContext } from 'react';
import SelectionContext from 'contexts/SelectionContext';

const useSelection = () => {
  const context = useContext(SelectionContext);
  if (!context) throw new Error('useSelection must be used within a SelectionProvider');
  return context;
};

export default useSelection;
